import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.rateEditPage || initialState;

export const selectTariffData = createSelector(
    [selectDomain],
    state => state.tariffData,
);

export const selectRateData = createSelector(
    [selectDomain],
    state => state.rateData,
);

export const selectLoading = createSelector(
    [selectDomain],
    state => state.loading,
);
export const selectLoadingTariffs = createSelector(
    [selectDomain],
    state => state.loadingTariffs,
);

export const selectLoadingOptions = createSelector(
    [selectDomain],
    state => state.loadingOptions,
);

export const selectOptionData = createSelector(
    [selectDomain],
    state => state.optionData,
);
